module.exports = __webpack_public_path__ + "media/images/feedback_desktop-5c4e342b5c85a027761e2c81bf66a57d.png";